/**
 * @generated SignedSource<<ed7d66c560c868af2d8c5196f62a89b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endts"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellername"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startts"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unapprovedOnly"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendorAccountId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "endts",
        "variableName": "endts"
      },
      {
        "kind": "Variable",
        "name": "resellername",
        "variableName": "resellername"
      },
      {
        "kind": "Variable",
        "name": "startts",
        "variableName": "startts"
      },
      {
        "kind": "Variable",
        "name": "unapprovedonly",
        "variableName": "unapprovedOnly"
      },
      {
        "kind": "Variable",
        "name": "vendoraccountid",
        "variableName": "vendorAccountId"
      }
    ],
    "concreteType": "PayoutLinesConnection",
    "kind": "LinkedField",
    "name": "getpayoutlines2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorPayoutActionIconQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VendorPayoutActionIconQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "a252ce3eba9e8954ebf0be47101c58c2",
    "id": null,
    "metadata": {},
    "name": "VendorPayoutActionIconQuery",
    "operationKind": "query",
    "text": "query VendorPayoutActionIconQuery(\n  $vendorAccountId: UUID!\n  $resellername: String\n  $unapprovedOnly: Int\n  $startts: Datetime\n  $endts: Datetime\n) {\n  getpayoutlines2(vendoraccountid: $vendorAccountId, resellername: $resellername, unapprovedonly: $unapprovedOnly, startts: $startts, endts: $endts) {\n    totalCount\n  }\n}\n"
  }
};
})();

node.hash = "789a3d4a84e8bdd368be02e9521f2a49";

module.exports = node;
